// extracted by mini-css-extract-plugin
export var cartContainer = "_mg-4";
export var gray = "_mg-1";
export var itemContainer = "_mg-2";
export var itemDetails = "_mg-3";
export var strong = "_mg-0";